import React, { useContext, useState } from 'react'
import { CompanyStaffType } from 'types'
import { StaffBoxCardContent } from './Cards/StaffBoxCardContent'
import { StaffBoxCardEdit } from './Cards/StaffBoxCardEdit'
import {
  CloseCircleOutlined,
  DownCircleOutlined,
  EditOutlined,
  UpCircleOutlined,
} from '@ant-design/icons'
import { Card } from 'antd'
import { StaffItemCardBtns } from './styles'
import { AbilityContext } from 'contexts/abilityContext'

interface IProps {
  editable?: boolean
  staff: CompanyStaffType
}
export const StaffBoxItem = (props: IProps) => {
  const { editable = true, staff } = props
  const [editMode, setEditMode] = useState(false)
  const [expanded, setExpanded] = useState(false)
  const displayEdition = editMode && editable
  const ability: any = useContext(AbilityContext)

  const toggleExpanded = () => setExpanded(!expanded)

  const toggleEditMode = () => {
    setEditMode(!editMode)
  }

  return (
    <Card
      bordered
      title={`#${staff.id}`}
      extra={
        <StaffItemCardBtns>
          {/*edition btns*/}
          {ability.can('manage', 'CompanyStaff') && !editMode && editable && (
            <EditOutlined
              width={'1.5em'}
              height={'1.5em'}
              onClick={toggleEditMode}
            />
          )}
          {editMode && (
            <CloseCircleOutlined
              width={'1.5em'}
              height={'1.5em'}
              onClick={toggleEditMode}
            />
          )}
          {/*extension btns*/}
          {!editMode && !expanded && (
            <DownCircleOutlined
              width={'1.5em'}
              height={'1.5em'}
              onClick={toggleExpanded}
            />
          )}
          {!editMode && expanded && (
            <UpCircleOutlined
              width={'1.5em'}
              height={'1.5em'}
              onClick={toggleExpanded}
            />
          )}
        </StaffItemCardBtns>
      }
    >
      {displayEdition ? (
        <StaffBoxCardEdit toggleEditMode={toggleEditMode} staff={staff} />
      ) : (
        <StaffBoxCardContent expanded={expanded} staff={staff} />
      )}
    </Card>
  )
}
